import { app, initializeOdinApp } from './firebaseOdinInit'
import { getAuth, signInWithCustomToken, setPersistence, browserSessionPersistence, signOut } from 'firebase/auth'
import { getFirestore, onSnapshot, collection, doc, Firestore } from 'firebase/firestore'

initializeOdinApp()
const auth = getAuth()
const db: Firestore = getFirestore(app)

export const firebaseSignInWithCustomToken = async (token: string, errorHandler: (error: any) => void) => {
  try {
    await setPersistence(auth, browserSessionPersistence)
    const userCredential = await signInWithCustomToken(auth, token)
    return userCredential
  } catch (error) {
    const errorCode = error.code
    const errorMessage = error.message
    console.error(errorCode, errorMessage)
    errorHandler(error)
    return null
  }
}
export const firebaseSignOut = async () => {
  try {
    signOut(auth)
  } catch (error) {
    return error
  }
}
export const firebaseSetListener = (path: string, id: string, listener: (snapshot: any) => void) => {
  const options = { includeMetadataChanges: false }
  if (id) {
    return onSnapshot(doc(db, path, id), options, listener)
  }
  return onSnapshot(collection(db, path), options, listener)
}
